﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import UppAppDownloadPage from "./Component";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default UppAppDownloadPage;
